<template>
  <div class="ride-booking">
    <MainBackButton :forceHome="true" />

    <RideBookingPanel
      :order="order"
      @toggleHeight="toggleHeight"
      @update="init"
    />

    <p v-if="order" class="header" @click="init">
      {{ name }}
      <i v-if="isUpdating" class="fa fa-spinner fa-spin has-text-success" />
    </p>

    <!-- Otherwise could show blank map until order ready -->
    <RideBookingMap
      v-if="order"
      :t="order"
      :isTall="isTall"
      :key="order.hash"
    />
  </div>
</template>


<script>
import MainBackButton from "@/components/MainBackButton";
import RideBookingPanel from "@/components/RideBookingPanel.vue";
import RideBookingMap from "@/components/RideBookingMap.vue";

export default {
  name: "RideBooking",
  components: {
    MainBackButton,
    RideBookingPanel,
    RideBookingMap,
  },
  data() {
    return {
      order: null,
      isTall: false,
      isUpdating: false,
      pollInterval: null,
    };
  },
  computed: {
    name() {
      if (!this.order) return null;
      if (this.isPrivate) return this.order.business.name;
      return this.order.workflow.name;
    },
    id() {
      return this.$route.params.id;
    },
    isPrivate() {
      // need to check both "Private" and "Private Tuk Tuk"
      return this.order.workflow_type_name === "Private Tuk Tuk";
    },
  },
  mounted() {
    this.subscribeToStore();
    this.watchVisibility();
    this.poll();
  },
  activated() {
    this.init();
  },
  beforeDestroy() {
    if (this.pollInterval) clearInterval(this.pollInterval);
  },
  methods: {
    init() {
      if (!this.id) return;
      if (this.order) {
        if (this.order.id !== this.id) this.order = null; // new order
      }
      this.getRideOrder();
    },
    toggleHeight(bool) {
      this.isTall = bool;
    },
    getRideOrder() {
      if (this.$route.name !== "ride-booking") return;
      this.isUpdating = true;
      this.$store
        .dispatch("getRideOrder", this.id)
        .then((res) => this.updateOrder(res.data))
        .catch((err) => this.apiError(err))
        .finally(() => (this.isUpdating = false));
    },
    updateOrder(data) {
      if (data) this.order = data;
      else this.warningAlert("No order data!");
    },
    subscribeToStore() {
      this.$store.subscribe((mutation) => {
        if (mutation.type === "setTransactionsForCustomer") {
          this.init(); //   this.updatePassengerTransaction();
        }
        if (mutation.type === "newNotification") {
          this.init();
        }
      });
    },
    watchVisibility() {
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden") return;
        this.updateTrips(false); // force update transactions whenever customer comes to this page
      });
    },
    poll() {
      this.pollInterval = setInterval(() => {
        this.init();
      }, 1000 * 30); // ping ever 30 seconds
    },
  },
};
</script>


<style scoped>
.header {
  position: absolute;
  margin-top: 15px;
  margin-left: 57px;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 0px 6px;
  border-radius: 3px;
  box-shadow: 1px 1px 2px grey;
  font-size: 1.1em;
  font-weight: 500;
}
</style>